import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

function Callback() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      // Check if user has completed onboarding
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      
      if (user.has_completed_onboarding) {
        navigate('/');
      } else {
        navigate('/onboarding');
      }
    }
  }, [isAuthenticated, isLoading, navigate]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #F7F3EC 0%, #EFE7DD 30%, #B8D3CF 70%, #A8E6CE 100%)'
    }}>
      <div style={{
        fontSize: '2rem',
        marginBottom: '20px',
        animation: 'spin 1s linear infinite'
      }}>
        ✨
      </div>
      <h2 style={{
        fontFamily: "'Playfair Display', serif",
        color: '#1E6B68',
        fontSize: '1.5rem'
      }}>
        Completing authentication...
      </h2>
      <p style={{
        color: '#666',
        marginTop: '10px'
      }}>
        Please wait while we set up your account
      </p>
    </div>
  );
}

export default Callback;
